<template>
  <div>
    <NavigationView />
    <div class="h-[800px]">
      <div class="flex flex-col h-full justify-center items-center">
        <h1 class="text-[100px] md:text-[200px]">404</h1>
        <p class="text-[20px] md:text-[30px]">Page Not Found</p>

        <a href="/" class="pt-3">
          <button
            class="font-bold py-2 px-3 text-black bg-[#f8c300] rounded-3xl"
          >
            Go to Home
          </button>
        </a>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script>
import NavigationView from "@/components/NavigationView.vue";
import FooterView from "@/components/Home/FooterView.vue";

export default {
  name: "PageNotFoundView",
  components: {
    NavigationView,
    FooterView,
  },
  mounted() {
    // Redirect to /lp/online and append the query parameter ?utm_source=page_not_found
    this.$router.push({
      name: "OnlineView",
      params: { slug: "online" },
      query: { utm_source: "page_not_found" },
    });
  },
};
</script>

<style>
/* Add any styles here if needed */
</style>
